import React from 'react';
import { Box, Flex, Icon, NakedButton } from '@qga/roo-ui/components';
import PropTypes from 'prop-types';

import FullPageModalContext from '../../FullPageModalContext';

/**
 * @param {{ children: React.ReactNode }} props
 */
const Header = ({ children }) => (
  <FullPageModalContext.Consumer>
    {({ onClose }) => (
      <Box
        bg="white"
        p="3"
        borderBottom="1"
        borderColor="greys.alto"
        position="relative"
      >
        <Box fontSize="sm" fontWeight="bold" textAlign="center">
          {children}
        </Box>
        <Flex
          position="absolute"
          right="0"
          top="0"
          bottom="0"
          pr="5"
          alignItems="center"
        >
          <NakedButton onClick={onClose} data-testid="CLOSE_BUTTON">
            <Icon name="close" />
          </NakedButton>
        </Flex>
      </Box>
    )}
  </FullPageModalContext.Consumer>
);

Header.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Header;
